import React from "react";
import ViewOnMapComponent from "../../../components/StoreModule/ViewOnMap/viewonmap.component"

export default class ViewOnMapScreen extends React.Component {
  render() {
    return <ViewOnMapComponent></ViewOnMapComponent>
  }
}